import { Components, Theme } from '@mui/material'

declare module '@mui/material/LinearProgress' {
  interface LinearProgressProps {
    // LinearProgress has no slots API to strip custom props from the root <span>, and its root is a
    // styled('span'), so `size`/`shape` props would reach the DOM as invalid attributes. Data
    // attributes are valid there and still match in `variants`.
    'data-size'?: 'sm' | 'md' | 'lg'
    'data-shape'?: 'rounded' | 'square'
  }
}

export const MuiLinearProgress: Components<Omit<Theme, 'components'>>['MuiLinearProgress'] = {
  defaultProps: {
    'data-size': 'md',
    'data-shape': 'rounded',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape['radius-full'],
      backgroundColor: theme.palette.bg.neutral.muted,
    }),
    bar: ({ theme }) => ({
      backgroundColor: theme.palette.bg.brand.default,
      borderRadius: theme.shape['radius-full'],
    }),
  },
  variants: [
    {
      props: { 'data-size': 'sm' },
      style: {
        height: '4px',
      },
    },
    {
      props: { 'data-size': 'md' },
      style: {
        height: '8px',
      },
    },
    {
      props: { 'data-size': 'lg' },
      style: {
        height: '10px',
      },
    },
    {
      props: { 'data-shape': 'square' },
      style: {
        borderRadius: 0,
        '& .MuiLinearProgress-bar': {
          borderRadius: 0,
        },
      },
    },
  ],
}
